module.exports = __webpack_public_path__ + "img/02 Animation 2-squashed.71256c03.jpg";